var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "stretch": ""
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.left",
      value: (3),
      expression: "3",
      modifiers: {
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.right",
      value: (3),
      expression: "3",
      modifiers: {
        "right": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "headline"
    }
  }, [_vm._v("\n            Расходы\n        ")])], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "empty": "Расходов нет",
      "loader": _vm.loading,
      "sort": _vm.sort,
      "headers": _vm.headers,
      "records": _vm.records
    },
    on: {
      "sort": function($event) {
        _vm.$emit('sort', $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "cell-datetime",
      fn: function(props) {
        return [_c('v-text', {
          attrs: {
            "nowrap": ""
          }
        }, [_vm._v("\n                " + _vm._s(_vm.moment(props.item.datetime).format('DD.MM.YYYY HH:mm')) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "total": _vm.total,
      "display": _vm.display,
      "current": _vm.page
    },
    on: {
      "click": function($event) {
        _vm.$emit('paginate', $event)
      }
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f224cf4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/costs/Costs.vue
// module id = 999
// module chunks = 0